import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Structures } from '@clavisco/core';
import ICLResponse = Structures.Interfaces.ICLResponse;
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private http: HttpClient,
  ) { }

  /**
 * Fetches the spreadsheet report for a given document ID.
 * 
 * @param docId - The document ID for which to fetch the report.
 * @returns An observable containing the response with the report data (base64 encoded string).
 */
  GetReportSpredsheet(docId: number): Observable<ICLResponse<string>> {
    const params = new HttpParams()
      .set('docId', docId)
    return this.http.get<ICLResponse<string>>(`api/Report/GetReportSpredsheet`, { params });
  }

}
